/* Merdeka fireworks — the canvas field behind the campaign hero.

   Ported verbatim from the design prototype, which drew this in a React
   component's fireworks() method. The DOM capture brought the <canvas> across
   but not the script, so the element shipped at width="0" and the hero has been
   a plain black band ever since. Bursts are shells of sparks under gravity with
   drag and a fading trail, in flag yellow, red and white only, which is what
   keeps it inside the campaign's colour rules.

   Three things here are load-bearing rather than decorative:
   - prefers-reduced-motion returns before any canvas work, so the hero is a
     still black band rather than a paused animation;
   - the rAF loop stops on visibilitychange, because an unthrottled particle
     field in a background tab is a battery cost with nothing to show for it;
   - it re-measures on resize, since the canvas backing store does not follow
     its CSS box.
*/
(function () {
  'use strict';

  function start(cv) {
    if (cv.dataset.efFw) return;
    cv.dataset.efFw = '1';
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ctx = cv.getContext('2d');
    if (!ctx) return;
    var w = 0, h = 0, dpr = Math.min(devicePixelRatio || 1, 2);

    function size() {
      var r = cv.getBoundingClientRect();
      w = r.width; h = r.height;
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();
    if (!w || !h) return;

    var COLOURS = ['#ffcc00', '#ffffff', '#cc0001', '#ffe066'];
    var sparks = [];

    function burst(x, y) {
      var c = COLOURS[(Math.random() * COLOURS.length) | 0];
      var n = 46 + ((Math.random() * 26) | 0);
      var power = 2.1 + Math.random() * 1.5;
      for (var i = 0; i < n; i++) {
        var a = (i / n) * Math.PI * 2 + Math.random() * 0.14;
        var v = power * (0.65 + Math.random() * 0.5);
        sparks.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v,
                      life: 1, decay: 0.008 + Math.random() * 0.01, c: c,
                      r: 1 + Math.random() * 1.3 });
      }
    }

    var last = performance.now(), next = 400, acc = 0, raf = 0, alive = true;

    function frame(now) {
      if (!alive) return;
      var dt = Math.min(now - last, 48); last = now;
      acc += dt;
      if (acc > next && sparks.length < 1400) {
        acc = 0; next = 700 + Math.random() * 900;
        burst(w * (0.14 + Math.random() * 0.72), h * (0.12 + Math.random() * 0.42));
      }
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,0.14)';
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = sparks.length - 1; i >= 0; i--) {
        var p = sparks[i];
        p.vy += 0.026 * (dt / 16.7);
        p.vx *= 0.988; p.vy *= 0.988;
        p.x += p.vx * (dt / 16.7); p.y += p.vy * (dt / 16.7);
        p.life -= p.decay * (dt / 16.7);
        if (p.life <= 0 || p.y > h + 30) { sparks.splice(i, 1); continue; }
        ctx.globalAlpha = p.life < 0.5 ? p.life * 2 : 1;
        ctx.fillStyle = p.c;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * (0.5 + p.life * 0.5), 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
      raf = requestAnimationFrame(frame);
    }
    raf = requestAnimationFrame(frame);

    function onVis() {
      if (document.hidden) { alive = false; cancelAnimationFrame(raf); }
      else if (!alive) { alive = true; last = performance.now(); raf = requestAnimationFrame(frame); }
    }
    addEventListener('resize', size, { passive: true });
    document.addEventListener('visibilitychange', onVis);
    burst(w * 0.5, h * 0.3);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-ef-fireworks]').forEach(start);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();


/* ---------------------------------------------------------------------------
 * The offer dialogue.
 *
 * <dialog>.showModal() rather than a div with a z-index: the browser supplies
 * focus trapping, Esc-to-close, an inert background and the top layer, and a
 * hand-rolled modal gets at least one of those wrong. The element ships CLOSED
 * and is opened here, so with JavaScript off there is no dialogue at all
 * rather than a panel nobody can dismiss.
 *
 * Shown ONCE. A promotional interstitial on every page view is the pattern
 * that teaches people to close your site, so the dismissal is remembered
 * per-campaign: the key carries the end date, so next campaign shows again
 * without anyone having to clear anything.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  var dlg = document.querySelector('[data-ef-promodal]');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  /* Keyed to the campaign, not to the site. */
  var KEY = 'ef-promodal-' + (dlg.getAttribute('data-ef-promodal') || 'v1');

  function seen() {
    try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function remember() {
    /* Private windows and blocked site data THROW on write, and an exception
     * here would leave the dialogue open with a dead close button. */
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function close() {
    remember();
    if (dlg.open) dlg.close();
  }

  Array.prototype.forEach.call(
    dlg.querySelectorAll('[data-ef-promodal-close]'),
    function (b) { b.addEventListener('click', close); });

  /* Esc fires 'cancel' before 'close'; remember it there too, or dismissing
   * with the keyboard shows the dialogue again on the next page. */
  dlg.addEventListener('cancel', remember);
  dlg.addEventListener('close', remember);

  /* Clicking the backdrop. A <dialog>'s backdrop is part of the element, so a
   * click outside .ef-promodal__body but inside the dialog is a backdrop
   * click - comparing against the body's own box is what tells them apart. */
  dlg.addEventListener('click', function (e) {
    var box = dlg.querySelector('.ef-promodal__body');
    if (!box) return;
    var r = box.getBoundingClientRect();
    var inside = e.clientX >= r.left && e.clientX <= r.right &&
                 e.clientY >= r.top && e.clientY <= r.bottom;
    if (!inside) close();
  });

  /* Spin & Save takes priority when it's open — this dialogue's own CTA
   * already says as much once the wheel opens ("the more urgent of the two
   * offers", promo.py). Both dialogues used to share the same 1200ms delay,
   * so without a check like this a signed-in visitor during the campaigns'
   * overlap gets TWO showModal() calls firing at once, fighting for the top
   * layer. Found on the live site, not in testing — the two dialogues were
   * never actually tested running together, only in isolation.
   *
   * spinDone() being false does NOT mean "skip forever" — it means "not this
   * visitor's turn yet", so this dialogue still gets its turn once the spin
   * one is actually done (claimed), or never has to appear at all once its
   * campaign ends and [data-ef-spinmodal] stops existing in the DOM. */
  var spinDlg = document.querySelector('[data-ef-spinmodal]');
  var spinKey = spinDlg
    ? 'ef-spinmodal-' + (spinDlg.getAttribute('data-ef-spinmodal') || 'v1')
    : null;
  function spinDone() {
    if (!spinKey) return true;
    try { return localStorage.getItem(spinKey) === '1'; } catch (e) { return false; }
  }

  /* Shared by the load-time open below and the same-page-view handoff, so
   * both paths apply the exact same guard: never twice, never before spin
   * is actually done. */
  function open() {
    if (seen() || dlg.open || !spinDone()) return;
    dlg.showModal();
    /* Remembered on SHOW, not on close. The brief was "first page only", and
     * recording it at dismissal missed every visitor who left without
     * dismissing — a browser Back, a closed tab, a reload — so the dialogue
     * came back on their next page. Seeing it is what has happened; whether
     * they pressed the x is a separate question. */
    remember();
  }

  /* The moment spin's own dialogue closes — ef-spin.js dispatches this on
   * its native 'close' event, which covers the X, Esc, a backdrop click, and
   * a claim followed by any of those — this one gets its turn on the SAME
   * page view if it's earned it, rather than waiting for a future page load
   * to re-run the check below. Closing spin without claiming does nothing
   * here: open()'s own spinDone() check quietly declines, exactly as it
   * would have on a reload. A short beat, not immediate, so the two
   * dialogues' close/open transition doesn't read as one flickering into
   * the other. */
  document.addEventListener('ef-spin-dialog-closed', function () {
    window.setTimeout(open, 300);
  });

  if (seen()) return;
  if (spinDlg && !spinDone()) return;

  /* A beat after load. Opening during the first paint fights the hero for
   * attention and reads as an error; it also lets a reader who arrived for
   * one specific thing get to it first. */
  window.setTimeout(open, 1200);
})();
